module.exports = __webpack_public_path__ + "img/vr2.a7cb83fa.jpg";